import React from 'react'

const Sidebar = () => {
  return (
    <div>
    <ul className='flex flex-col justify-center mt-10 align-center font-roboto'>
      <div className=''>
        <li className='border-b border-t border-gray-500 pl-8 py-1'>Bam Overview</li>
        <li className='border-b pl-8 py-1 border-gray-500 bg-gray-500'>Send SMS</li>
        <li className='border-b pl-8 py-1 border-gray-500'>Add Sender ID</li>
        <li className='border-b pl-8 py-1 border-gray-500'>View Reports</li>
        <li className='border-b pl-8 py-1 border-gray-500'>Resources</li>
        <li className='border-b pl-8 py-1 border-gray-500'>Back to Workspace</li>
        <li className='border-b pl-8 py-1 border-gray-500'>My Account</li>
      </div>
      
    </ul>
    
</div>
  )
}

export default Sidebar